<style lang="stylus" scoped>
.potocal-page
  background-color white
  .paragraph
    font-size 28px
    line-height 40px
    color #1d1d1d
    box-sizing border-box
  .empty
    font-size 38px
    line-height 50px
    padding-top 100px
    text-align center
    color #777
.potocal-page >>> .ql-editor
  white-space normal
.custom-image
  margin-top 10px
</style>

<template>
  <div class="potocal-page">
    <!-- 父元素这里需要引入 ql-editor 类 才能使quill css 生效-->
    <div class="paragraph ql-editor" v-html="content"></div>
    <p class="empty">{{errMessage}}</p>
  </div>
</template>

<script>
import { setPageTitle } from '../../common/utils'
// import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

export default {
  name: 'Potocol',

  data () {
    return {
      content: '',
      errMessage: ''
    }
  },

  computed: {
    //
  },

  created () {
    const { name = '' } = this.$route.params
    if (!name) {
      this.errMessage = '暂无该页面'
      this.content = ''
      return
    }
    try {
      const file = require(`./base/${name}`)
      if (file && file.default) {
        const { content, title } = file.default
        this.content = content
        setPageTitle(title)
      } else {
        this.errMessage = '暂无内容'
        this.content = ''
      }
    } catch (e) {
      this.errMessage = '404 not found'
      this.content = ''
    }
  },

  methods: {
  }
}
</script>
